// extracted by mini-css-extract-plugin
export default {"formWrap":"yYdco","contactNumberInput":"pHnXo","buttonPreloader":"Bi81V","submitContainer":"oGost","withCaptcha":"FT0qZ","captchaWrapper":"yf8TO"};